import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../utils/propUtils';
import VeltPresenceAvatarListWireframe from './VeltPresenceAvatarListWireframe/VeltPresenceAvatarListWireframe';
import VeltPresenceAvatarRemainingCountWireframe from './VeltPresenceAvatarRemainingCountWireframe/VeltPresenceAvatarRemainingCountWireframe';
var VeltPresenceWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-presence-wireframe", __assign({}, transformedProps), children));
};
VeltPresenceWireframe.AvatarList = VeltPresenceAvatarListWireframe;
VeltPresenceWireframe.AvatarRemainingCount = VeltPresenceAvatarRemainingCountWireframe;
export default VeltPresenceWireframe;
